<template>
    <div class="basic_wrap cust2">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('My Coupons')}}</div>
            <div class="detail font-14 color-white"></div>
        </div>

        <van-empty v-if="!couponList" image="error">
            <template #description>
                <span style="color: #fff;">{{$t('No coupons.')}}</span>
            </template>
        </van-empty>

        <van-tabs v-if="couponList" v-model="active">
            <van-tab :title="$t('Unused')">
                <div class="content-wrap">
                    <div class="mb-10" v-for="i in filterCoupons(0)" :key="i.id">
                        <img @click="onCouponClick(i.id)" src="@/assets/images/invite_coupon.png"/>
                    </div>
                </div>
            </van-tab>
            <van-tab :title="$t('In use')">
                <div v-if="filterCoupons(1).length" class="mb-10 coupon-item" v-for="i in filterCoupons(1)" :key="i.id">
                    <div class="custom_cell">
                        <img @click="onCouponClick(i.id)" src="@/assets/images/invite_coupon_use.png"/>
                        <van-cell :title="$t('Start time')" :value="i.start_time" />
                        <van-cell :title="$t('End time')" :value="i.end_time" />
                    </div>
                </div>
                <van-empty v-else image="error">
                    <template #description>
                        <span style="color: #fff;">{{$t('No coupons.')}}</span>
                    </template>
                </van-empty>
            </van-tab>
            <van-tab :title="$t('Expired')">
                <div v-if="filterCoupons(2).length" class="content-wrap">
                    <div class="mb-10" v-for="i in filterCoupons(2)" :key="i.id">
                        <img src="@/assets/images/invite_coupon_used.jpg"/>
                    </div>
                </div>
                <van-empty v-else image="error">
                    <template #description>
                        <span style="color: #fff;">{{$t('No coupons.')}}</span>
                    </template>
                </van-empty>
            </van-tab>
        </van-tabs>



        <!-- 规则 -->
        <div class="rule-wrap">
            <div class="font-14">{{rule.title}}</div>
            <div class="mt-20" v-html="rule.content"></div>
        </div>

    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";
    import {Dialog, Toast} from "vant";

    export default {
        name: "coupon",
        data() {
            return {
                couponList: {},
                rule: {},
                active: 0,
            }
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.getData();
        },
        methods: {
            // 按状态筛选优惠券
            filterCoupons(status) {
                return this.couponList.filter((item) => item.status === status);
            },
            // 初始化数据
            getData() {
                Fetch('/user/couponData').then(r => {
                    this.couponList = r.data.list;
                    this.rule = r.data.rule;
                })
            },
            // 处理使用优惠券
            onCouponClick(id) {
                Dialog.confirm({
                    title: this.$t('Confirm'),
                    message: this.$t('Are you sure you want to use this coupon?'),
                    confirmButtonText: this.$t('utils.confirm'),
                    cancelButtonText: this.$t('utils.cancel'),
                    confirmButtonColor: '#EF4444' // 红色确认按钮
                })
                .then(() => {
                    this.handleUseCoupon(id);
                })
                .catch(() => {
                    Toast(this.$t('Operation canceled'));
                });
            },
            handleUseCoupon(id) {
                Fetch('/user/useCoupon', { id: id }).then(res => {
                    if(res.code == 0){
                        this.$toast(res.msg);
                        return;
                    }

                    let _this = this;
                    _this.$toast(_this.$t('Success'));
                    setTimeout(function (){
                        _this.getData()
                    },1000)
                });
            },
        },
    }
</script>

<style lang="less" scoped>
    #app {
        background: #99c999 !important;
        min-height: 100vh;
    }
    .basic_wrap {
        background: #99c999 !important;
        min-height: 100vh;
    }
    .red_top_bg {
        /*height: 126px;*/
        background: unset!important;
        /*position: fixed;*/
    }
    .content-wrap {
        margin: 15px;
        border-radius: 8px;
        /*padding: 20px;*/
        /*background: #fff;*/
    }
    .content-wrap img {
        width: 100%;
    }
    .rule-wrap {
        background: #fff;
        border-radius: 8px;
        padding: 20px;
        margin: 15px;
    }
    .coupon-item {
        margin: 15px;
        padding: 15px 10px;
        background: #fff;
        border-radius: 8px;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    }
    .coupon-item img {
        width: 100%;
    }
</style>